import axios from 'axios';

// Define a baseURL para o backend FastAPI
// Em produção (HTTPS), usa automaticamente a URL HTTPS da API
const getBaseURL = () => {
  // Se REACT_APP_API_URL está definida, usa ela
  if (process.env.REACT_APP_API_URL) {
    console.log('🔧 API URL (env):', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // Se estiver em produção (HTTPS), usa a URL HTTPS da API
  if (window.location.protocol === 'https:') {
    console.log('🔒 Detectado HTTPS, usando API HTTPS');
    return 'https://api.conectachurch.com.br';
  }
  
  // Desenvolvimento local
  console.log('💻 Desenvolvimento local');
  return 'https://api.conectachurch.com.br';
};

const baseURL = getBaseURL();
console.log('🌐 API Base URL configurada:', baseURL);

const api = axios.create({
  baseURL: baseURL,
});

// Adiciona o token JWT automaticamente em todas as requisições, se existir
let _csrfToken = null;

async function fetchCsrfToken() {
  if (_csrfToken) return _csrfToken;
  try {
    const resp = await axios.get(`${baseURL}/csrf-token`);
    _csrfToken = resp.data.csrf_token;
    return _csrfToken;
  } catch {
    return null;
  }
}

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
      const csrf = await fetchCsrfToken();
      if (csrf) config.headers['X-CSRF-Token'] = csrf;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Limpa token expirado/inválido e redireciona para login no 401
let _redirectingToLogin = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentToken = localStorage.getItem('token');
      const alreadyOnLogin = window.location.pathname === '/login';
      if (currentToken && !alreadyOnLogin && !_redirectingToLogin) {
        _redirectingToLogin = true;
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else if (!alreadyOnLogin) {
        // sem token e fora do login: só remove qualquer resquício
        localStorage.removeItem('token');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
